import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sell-buttons',
  templateUrl: './sell-buttons.component.html',
  styleUrls: ['./sell-buttons.component.scss']
})
export class SellButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  sellOn(website: string) {
    switch (website) {
      case 'kijiji':
        window.open('https://www.kijiji.it/pubblica-annuncio', '_blank');
        break;
      case 'subito':
        window.open('https://www2.subito.it/aif', '_blank');
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/sell-buttons/sell-buttons.component.ts